import * as React from 'react'
import {ReactElement} from 'react'
import {Box} from '@mui/material'
import {Colors, FontSize} from '../../../../styledComponents/Constants'
import {FullWidthColumnFlexContainer, LeftRowFlexContainer} from '../../../../styledComponents/FlexComponents'
import {BlockSpacer} from '../../../../styledComponents/ResponsiveConvenience'
import {PlainBackLink} from '../../../../styledComponents/Links'
import {DisplayItemDividerForPageTop} from '../../../../styledComponents/DisplayItem'
import {
    ApplyButton,
    BoldText,
    ListGridContainer,
    PageTitle,
    PledgeArea,
    PolicyCheckBoxStyled,
    WideWhiteArea,
} from '../common/resident/NatResidentApplicationsCommon'
import {
    createResidentWithErrorHandlingPage,
    ResidentWithErrorHandlingPagePropsSet,
} from '../../../../components/shared/hoc/createResidentWithErrorHandlingPage'
import {Nullable} from '../../../../app/TypeHelpers'
import {Location} from 'react-router-dom'

interface Props {
    condominiumCd: string
    applyId?: string
    location: Location
}

interface State {
    policyChecked: boolean
    applyButtonDisabled: boolean
}

class NatResidentWindowFilmAttachAgreementPage
    extends React.Component<Props & ResidentWithErrorHandlingPagePropsSet, State> {

    constructor(props: Props & ResidentWithErrorHandlingPagePropsSet) {
        super(props)

        this.state = {
            policyChecked: false,
            applyButtonDisabled: true,
        }

        this.onChangePolicyChecked = this.onChangePolicyChecked.bind(this)
        this.onClickApplyButton = this.onClickApplyButton.bind(this)
    }

    onChangePolicyChecked(event: React.ChangeEvent<HTMLInputElement>): void {
        this.setState({
            policyChecked: event.target.checked,
        }, () => {
            this.updateApplyButtonDisabled()
        })
    }

    updateApplyButtonDisabled(): void {
        const {policyChecked} = this.state

        if (policyChecked) {
            this.setState({applyButtonDisabled: false})
        } else {
            this.setState({applyButtonDisabled: true})
        }
    }

    onClickApplyButton(): void {
        this.props.navigate(
            `/resident/condominiums/${this.props.condominiumCd}/applications/windowFilmAttaches/input`,
            {state: {applyId: this.props.applyId}},
        )
    }

    renderPolicy(): Nullable<ReactElement> {
        return (<>
            <Box height={'15px'}/>
            <PledgeArea fontSize={FontSize.Middle}>
                <Box p={'10px'}>
                    <BoldText fontColor={Colors.AccentDark}>誓約文</BoldText>
                    <Box height={'5px'}/>
                    私は、窓ガラスへのフィルム貼付を実施したいので、次の通り申込をいたします。<br/>
                    なお当該フィルム貼付を原因として生じた問題（ガラスの熱割れを含む）を自主的に解決し、フィルム
                    の貼付内容が規則に違反した場合は、私の責任においてフィルムの変更または原状回復をいたします。
                </Box>
            </PledgeArea>
            <Box height={'20px'}/>
            <FullWidthColumnFlexContainer>
                <PolicyCheckBoxStyled>
                    <LeftRowFlexContainer>
                        <input
                            type="checkbox"
                            checked={this.state.policyChecked}
                            onChange={this.onChangePolicyChecked}
                        />
                        <BlockSpacer width={'10px'}/>
                        誓約文に同意する
                    </LeftRowFlexContainer>
                </PolicyCheckBoxStyled>
            </FullWidthColumnFlexContainer>
        </>)
    }

    render(): ReactElement {
        return (
            <>
                <PlainBackLink to={this.props.applyId
                    ? `/resident/condominiums/${this.props.condominiumCd}/applications/windowFilmAttaches/${this.props.applyId}`
                    : `/resident/condominiums/${this.props.condominiumCd}/applications`}
                >
                    戻る
                </PlainBackLink>
                <BlockSpacer height={'16px'}/>
                <DisplayItemDividerForPageTop/>
                <BlockSpacer height={'30px'}/>
                <PageTitle>
                    窓ガラスフィルム貼付申請
                </PageTitle>
                <Box height={'20px'}/>
                <Box>
                    窓ガラスフィルムの貼付を行う場合に提出が必要です。
                    <Box height={'10px'}/>
                    <ListGridContainer fontSize={FontSize.Middle}>
                        <div>・</div>
                        <div>
                            窓ガラスフィルム運用規則を事前にご確認いただいたうえで本申請手続きを実施してください。
                        </div>
                        <div>・</div>
                        <div>
                            理事会にて審査を実施するため、申請結果の通知までにお時間をいただくことがございます。
                        </div>
                    </ListGridContainer>
                </Box>
                <Box height={'15px'}/>
                <WideWhiteArea>
                    <Box mt={'15px'}>
                        <BoldText fontColor={Colors.AccentDark}>ご提出いただくもの</BoldText>
                        <Box height={'5px'}/>
                        <ListGridContainer fontSize={'16px'}>
                            <div>・</div>
                            <div>
                                仕様書
                            </div>
                            <div>・</div>
                            <div>
                                取付け位置図
                            </div>
                            <div>・</div>
                            <div>
                                ガラスの熱割れ計算書
                            </div>
                        </ListGridContainer>
                        <Box height={'15px'}/>
                    </Box>
                </WideWhiteArea>
                {this.renderPolicy()}
                <ApplyButton
                    disabled={this.state.applyButtonDisabled}
                    onClick={this.onClickApplyButton}>
                    <FullWidthColumnFlexContainer>
                        <div>
                            申請を開始する
                        </div>
                    </FullWidthColumnFlexContainer>
                </ApplyButton>
            </>
        )
    }
}

export default createResidentWithErrorHandlingPage(NatResidentWindowFilmAttachAgreementPage)
